import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import { usePropertyOwnedThroughoutDevelopment } from '../../../../../../queries/PropertyFields/BridgeFields';

interface OwnedThroughoutDevelopmentProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
    labelSize?: ToggleButtonLabelSize;
}

export const OwnedThroughoutDevelopment: React.FC<OwnedThroughoutDevelopmentProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
    labelSize = ToggleButtonLabelSize.Medium,
}) => {
    const label = 'Did you own the Property throughout the construction or renovation?';

    const [ownedThroughoutDevelopment, set_ownedThroughoutDevelopment] = usePropertyOwnedThroughoutDevelopment(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_ownedThroughoutDevelopment(true);
                return;
            case 'no':
                set_ownedThroughoutDevelopment(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={ownedThroughoutDevelopment ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonOwnedThroughoutDevelopment'
                    value={ownedThroughoutDevelopment}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='This field is required.'
                    label={label}
                    labelSize={labelSize}
                />
            )}
        </>
    );
};
